'use client';

import './styles.css';

import clsx from 'clsx';
import Image from 'next/image';
import { useMetrica } from 'next-yandex-metrica';

import { ChevronRightIcon } from '@/shared';

import { Button } from '../../';
import { trackCommunityClick } from '../../community-analytics';
import type { ICTAStartLearn } from '../../types';

export const CTAStartLearnV2 = ({
	title,
	description,
	buttonText,
	buttonHref,
	image,
	imagePosition = 'right',
	backgroundImage,
	trackQuestionClick = false,
}: ICTAStartLearn & { trackQuestionClick?: boolean }) => {
	const metrica = useMetrica();
	const backgroundStyle = backgroundImage
		? { backgroundImage: `url(${backgroundImage})` }
		: {};

	const contentElement = (
		<div
			className={clsx({
				'md:order-1': image && imagePosition === 'right',
				'md:order-2': image && imagePosition === 'left',
			})}
		>
			<h2 className="cta-title">{title}</h2>

			{Array.isArray(description) ? (
				<ul className="list-outside list-disc space-y-2 pl-4 text-base/[1.35] opacity-70 xl:pl-12 xl:text-2xl/[1.3]">
					{description.map((item, index) => (
						<li key={index}>{item}</li>
					))}
				</ul>
			) : (
				<p className="text-base/[1.6] opacity-70 xl:text-2xl/[1.6]">
					{description}
				</p>
			)}

			<div className="mt-6 xl:mt-12">
				<Button
					href={buttonHref}
					variant="white"
					size="72"
					className="cta-action"
					onClick={
						trackQuestionClick
							? () =>
									trackCommunityClick(metrica, 'question', {
										location: 'question_section',
									})
							: undefined
					}
				>
					{buttonText}
					<ChevronRightIcon className="size-5" />
				</Button>
			</div>
		</div>
	);

	const imageElement = image && (
		<div
			className={clsx(
				'mx-auto w-full max-w-[320px] flex-shrink-0 xl:max-w-[460px]',
				{
					'md:order-2': imagePosition === 'right',
					'md:order-1': imagePosition === 'left',
				},
			)}
		>
			<Image
				src={image.src}
				alt={image.alt}
				width={690}
				height={862}
				className="w-full max-w-[460px]"
			/>
		</div>
	);

	return (
		<div
			className={clsx('cta cta-start-learn', {
				'with-background': backgroundImage,
				'flex flex-col justify-between gap-12 md:flex-row': image,
			})}
			style={backgroundStyle}
		>
			{imagePosition === 'left' ? (
				<>
					{imageElement}
					{contentElement}
				</>
			) : (
				<>
					{contentElement}
					{imageElement}
				</>
			)}
		</div>
	);
};
